module.exports = __webpack_public_path__ + "static/Folio-Medium-a6475211c1e59324cc3bbc8a69168fa3.woff";